import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';

import getEnv from '@src/apis/shared/getEnv';

function HeadTags() {
  const HeadTagsId = getEnv('HEAP_ANALYTICS_ID');
  const NewRelicLicenseKey = getEnv('NEW_RELIC_LICENSE_KEY');
  const NewRelicApplicationId = getEnv('NEW_RELIC_APPLICATION_ID');

  // init New Relic Browser agent
  const newRelicOptions = {
    init: { distributed_tracing: { enabled: true }, privacy: { cookies_enabled: true }, ajax: { deny_list: ['bam.nr-data.net'] } }, // NREUM.init
    info: { beacon: 'bam.nr-data.net', errorBeacon: 'bam.nr-data.net', licenseKey: NewRelicLicenseKey, applicationID: NewRelicApplicationId, sa: 1 }, // NREUM.info
    loader_config: { accountID: '3071253', trustKey: '965178', agentID: NewRelicApplicationId, licenseKey: NewRelicLicenseKey, applicationID: NewRelicApplicationId } // NREUM.loader_config
  };

  // The New Relic agent loader code executes immediately on instantiation.
  // eslint-disable-next-line no-new
  new BrowserAgent(newRelicOptions);

  useEffect(() => {
    // Check if user is already logged in (page refresh case)
    const existingUuid = sessionStorage.getItem('uuid');

    if (existingUuid && window.heap) {
      window.heap.identify(existingUuid);
    }

    // Listen for future login events
    const handleUserAuthenticated = (event: Event) => {
      const customEvent = event as CustomEvent<{ uuid: string }>;
      const { uuid } = customEvent.detail;

      if (window.heap) {
        window.heap.identify(uuid);
      }
    };

    window.addEventListener('userAuthenticated', handleUserAuthenticated);

    return () => {
      window.removeEventListener('userAuthenticated', handleUserAuthenticated);
    };
  }, []);


  return (
    <Helmet>
      {HeadTagsId && (
        <script type="text/javascript">
          {`
          window.heap=window.heap||[],heap.load=function(e,t){window.heap.appid = e, window.heap.config = t = t || {};var r=document.createElement("script");r.type="text/javascript",r.async=!0,r.src="https://cdn.heapanalytics.com/js/heap-"+e+".js";var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(r,a);for(var n=function(e){return function(){heap.push([e].concat(Array.prototype.slice.call(arguments, 0)))}},p=["addEventProperties","addUserProperties","clearEventProperties","identify","resetIdentity","removeEventProperty","setEventProperties","track","unsetEventProperty"],o=0;o<p.length;o++)heap[p[o]]=n(p[o])};
          heap.load('${HeadTagsId}');
        `}
        </script>)}

    </Helmet>
  );
}

export default HeadTags;
